import type { TradeProWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import { getUnderlyingSymbolFromInstrument, parseInstrument } from 'src/lib/instrumentUtils';
import type { TradeProActions } from 'src/store/actions/widgets/tradePro';
import type { WidgetTabViewModel } from 'src/store/types';

export const tradeProReducer = (state: WidgetTabViewModel, action: TradeProActions): WidgetTabViewModel => {
    // Only process the state if it's a TradePro widget
    if (state.widget.type !== 'trade-pro' && state.widget.type !== 'trade-pro-multi') {
        return state;
    }

    const widget = state.widget as TradeProWidgetModel;
    switch (action.type) {
        case 'updateTradeProAccount':
        case 'userSelectedTradeProAccount': {
            return {
                ...state,
                widget: {
                    ...widget,
                    accountId: action.accountId,
                },
            };
        }
        case 'updateTradeProSymbol':
        case 'userSelectedNewTradeProSymbol': {
            return {
                ...state,
                widget: {
                    ...widget,
                    symbol: action.symbol,
                    // When the symbol is updated, also update the instrument
                    instrument: parseInstrument(action.symbol),
                },
            };
        }

        case 'updateTradeProInstrument':
        case 'linkingUpdateTradeProInstrument': {
            return {
                ...state,
                widget: {
                    ...widget,
                    // When the instrument is updated, also update the symbol
                    symbol: getUnderlyingSymbolFromInstrument(action.instrument),
                    instrument: action.instrument,
                },
            };
        }

        case 'updateTradeProQuantity': {
            return {
                ...state,
                widget: {
                    ...widget,
                    quantity: action.quantity,
                },
            };
        }

        default:
            return state;
    }
};
